import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Shot } from 'src/app/components/company/models/new/shot';
import { Selectable } from '../../types/selectable.type';

@Component({
	selector: 'bt-image-gallery',
	standalone: true,
	imports: [CommonModule, MatDialogModule],
	templateUrl: './image-gallery.component.html',
	styleUrl: './image-gallery.component.scss'
})
export class ImageGalleryComponent {
	readonly #dialogRef = inject(MatDialogRef<ImageGalleryComponent>);
	readonly data = inject<any>(MAT_DIALOG_DATA);
	shots: Selectable<Shot>[] = [];

	constructor() {
		if (this.data && this.data.shots) {
			this.shots = this.data.shots.map((shot: Shot) => ({ ...shot, selected: false }));
			if (this.shots.length > 0) {
				if (this.data.first) {
					const firstShotIndex = this.shots.findIndex((shot) => shot.id === this.data.first);
					if (firstShotIndex !== -1) {
						this.shots[firstShotIndex].selected = true;
					} else {
						this.shots[0].selected = true;
					}
				} else {
					this.shots[0].selected = true;
				}
			}
		}
	}

	goPrevious() {
		const currentIndex = this.shots.findIndex((shot) => shot.selected);
		if (currentIndex > 0) {
			this.shots[currentIndex].selected = false;
			this.shots[currentIndex - 1].selected = true;
		}
	}

	goNext() {
		const currentIndex = this.shots.findIndex((shot) => shot.selected);
		if (currentIndex < this.shots.length - 1) {
			this.shots[currentIndex].selected = false;
			this.shots[currentIndex + 1].selected = true;
		}
	}

	isLast(): boolean {
		const currentIndex = this.shots.findIndex((shot) => shot.selected);
		return currentIndex === this.shots.length - 1;
	}

	isFirst(): boolean {
		const currentIndex = this.shots.findIndex((shot) => shot.selected);
		return currentIndex === 0;
	}

	close() {
		this.#dialogRef.close();
	}

	isVideo(shot: Shot): boolean {
		if (shot.imgPath) {
			const path = shot.imgPath.toLowerCase();
			if (path.lastIndexOf('.mp4') > 0 || path.lastIndexOf('.mkv') > 0) {
				return true;
			}
		}
		return false;
	}
}
